import { useOptionalTeamContext } from '../context';
import { TeamInfo } from '../context/types';

/** Returns `TeamInfo` when inside a `TeamProvider`, or `null` otherwise. */
export function useOptionalTeamInfo(): TeamInfo | null {
  return useOptionalTeamContext()?.teamInfo ?? null;
}
